<blaze-nr
  [addRelatedButtonTpl]="addRelatedButtonTpl"
  [bypassLazyRendering]="bypassLazyRendering"
  [columnAddHandleTpl]="columnAddHandleTpl"
  [columnDividerTpl]="columnDividerTpl"
  [columnResizeHandleTpl]="columnResizeHandleTpl"
  [elements]="elements"
  [elementWrapperTpl]="elementWrapperTpl"
  [ids]="rootElementIdArray$ | async"
  [loadingIndicatorTpl]="loadingIndicatorTpl"
  [metadata]="metadata"
  [selectionOverlayTpl]="selectionOverlayTpl"
  [selectionToolbarTpl]="selectionToolbarTpl"
  [workflowErrorsTpl]="workflowErrorsTpl"
/>

<ng-template #loadingIndicatorTpl let-loading>
  @if (loading) {
    <div @fade class="loading-indicator canvas-loading-indicator" data-cy="Canvas:loading">
      <svg
        width="64"
        height="24"
        viewBox="0 0 64 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="20" cy="12" r="4" fill="currentColor">
          <animate attributeName="opacity" values="1;0;0;1" dur="1s" repeatCount="indefinite" />
        </circle>
        <circle cx="32" cy="12" r="4" fill="currentColor">
          <animate attributeName="opacity" values="0;1;0;0" dur="1s" repeatCount="indefinite" />
        </circle>
        <circle cx="44" cy="12" r="4" fill="currentColor">
          <animate attributeName="opacity" values="0;0;1;0" dur="1s" repeatCount="indefinite" />
        </circle>
      </svg>
    </div>
  }
</ng-template>
